(() => {
  const ROOT_SELECTOR = '[data-cugini-dimension-product]';
  const READY_CLASS = 'cugini-dimension-product--ready';

  const moneyValue = (text) => {
    const normalized = String(text || '').replace(/[^0-9.,-]/g, '').replace(/,/g, '');
    const value = Number.parseFloat(normalized);
    return Number.isFinite(value) ? value : 0;
  };

  const isShown = (element) => {
    if (!(element instanceof HTMLElement)) return false;
    const container = element.closest('.tpo_option-container');
    if (container?.classList.contains('tpo_hidden')) return false;
    return element.getClientRects().length > 0;
  };

  const initialize = (root) => {
    if (!(root instanceof HTMLElement) || root.dataset.cuginiGuardInitialized === 'true') return;

    const form = root.querySelector('form[action*="/cart/add"], form[data-type="add-to-cart-form"]');
    const button = root.querySelector('[ref="addToCartButton"], button[type="submit"][name="add"]');
    const status = root.querySelector('[data-cugini-dimension-status]');

    if (!(form instanceof HTMLFormElement) || !(button instanceof HTMLButtonElement)) return;

    root.dataset.cuginiGuardInitialized = 'true';
    root.dataset.cuginiVariantAvailable = button.disabled ? 'false' : 'true';

    let updateQueued = false;

    const setStatus = (message) => {
      if (status && status.textContent !== message) status.textContent = message;
    };

    const readState = () => {
      const optionSet = form.querySelector('.tpo_option-set-wrapper.tpo_has-option-set');
      const dimensions = Array.from(form.querySelectorAll('input.tpo_dimension_input:not([disabled])')).filter(isShown);
      const width = dimensions.find((input) => input.dataset.tpoDimension === 'x');
      const height = dimensions.find((input) => input.dataset.tpoDimension === 'y');
      const dimensionsComplete = Boolean(width?.value.trim() && height?.value.trim());
      const calculatedPrice = moneyValue(form.querySelector('.tpo_total-additional-price')?.textContent);
      const priceReady = calculatedPrice > 0;
      const variantAvailable = root.dataset.cuginiVariantAvailable !== 'false';
      const ready = Boolean(optionSet && width && height && dimensionsComplete && priceReady && variantAvailable);

      return { optionSet, width, height, dimensionsComplete, calculatedPrice, priceReady, variantAvailable, ready };
    };

    const update = () => {
      updateQueued = false;
      const state = readState();

      if (button.disabled === state.ready) button.disabled = !state.ready;
      button.setAttribute('aria-disabled', state.ready ? 'false' : 'true');
      root.classList.toggle(READY_CLASS, state.ready);

      if (!state.variantAvailable) {
        setStatus('This variation is currently unavailable.');
      } else if (!state.optionSet) {
        setStatus('Loading size and price options…');
      } else if (!state.width || !state.height) {
        setStatus('Choose a type, style, and finish to enter dimensions.');
      } else if (!state.dimensionsComplete) {
        setStatus('Enter width and height to calculate your price.');
      } else if (!state.priceReady) {
        setStatus('Check the dimensions entered; a valid price is required before adding this item.');
      } else {
        setStatus('Dimensions accepted. Review the calculated price, then add to cart.');
      }
    };

    const scheduleUpdate = () => {
      if (updateQueued) return;
      updateQueued = true;
      window.requestAnimationFrame(update);
    };

    form.addEventListener('input', scheduleUpdate);
    form.addEventListener('change', scheduleUpdate);

    form.addEventListener(
      'submit',
      (event) => {
        const state = readState();
        if (state.ready) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        scheduleUpdate();
        state.width?.focus();
      },
      true
    );

    root.addEventListener('variant:update', (event) => {
      const available = event.detail?.resource?.available;
      if (typeof available === 'boolean') root.dataset.cuginiVariantAvailable = String(available);
      window.setTimeout(scheduleUpdate, 0);
      window.setTimeout(scheduleUpdate, 250);
    });

    new MutationObserver(scheduleUpdate).observe(form, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'disabled'],
    });

    scheduleUpdate();
  };

  const scan = () => document.querySelectorAll(ROOT_SELECTOR).forEach(initialize);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', scan);
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
